import * as React from 'react';

export const Maintenance: React.FunctionComponent = (): React.ReactElement => {
  return (
      <div className="d-flex flex-column justify-content-center bg-lvl1" style={{ minHeight: 'calc(100vh - 114px)' }}>
    <section>
      <sg-error-page
        code={503}
        description-label="Platformization is currently under maintenance. Thank you for your patience."
        action-button-label="Contact us"
        action-button-link={window.globalConfiguration.url.support}
      ></sg-error-page>
    </section>
  </div>
  );
};
